import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme: any) => ({
  '@keyframes toLeft': {
    from: {
      transform: 'translate(448px)'
    },
    to: {
      transform: 'translate(0)'
    }
  },
  drawerPaper: {
    transform: 'translate(448px)',
    animation: 'toLeft 0.3s ease-in-out 0.5s forwards',
    fontFamily: 'Lato',
    width: '448px',
    '@media screen and (max-width: 960px)': {
      width: '100%'
    }
  },
  drawerOptions: {
    overflow: 'auto',
    backgroundColor: '#fff',
    height: '100%',
    padding: 20,
    width: '100%',
    '&::-webkit-scrollbar': {
      width: '6px',
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#555',
      borderRadius: 10
    }
  },
  titleClose: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  h2: {
    fontWeight: 'bold',
    color: theme.variables.colors['primaryColor'],
    margin: 0
  },
  label: {
    fontWeight: 'bold',
    color: '#596375',
    fontSize: '14px',
    margin: '5px 0'
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0px solid #000',
    borderRadius: '100%',
    width: 40,
    height: 40,
    color: '#596375',
    fontWeight: 'bold',
    backgroundColor: '#D8D8D8',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: '#ccc'
    },
    '& svg': {
      width: '30%',
      fontWeight: 'bold',
      fill: '#596375'
    }
  },
  containerButton: {
    width: 'calc(100% - 22px)',
    marginBottom: 10
  },
  button: {
    fontWeight: 400,
    backgroundColor: '#009358',
    color: '#fff',
    width: '100%',
    padding: 10
  },
  observationSpan: {
    marginTop: '0.25rem',
    fontSize: '0.625rem',
    letterSpacing: '0.44px',
    color: ' #78909C'
  },
  disabledField: {
    width: '100%',
    fontWeight: 'normal',
    '& div,input': {
      cursor: 'not-allowed',
      background: '#ededed',
      color: 'rgba(0, 0, 0, 0.87)'
    }
  }
}));
